// extracted by mini-css-extract-plugin
export default {"section":"Contact_section__9Wxix","container":"Contact_container__J1LZ1","formContainer":"Contact_formContainer__yr9RF","div":"Contact_div__P2qga"};